import styled from 'styled-components'

export default styled.div.attrs({
    className: `mw8 center ph3 ph0-ns`
})``